export default __webpack_public_path__ + "static/media/matching.5faec0ab.jpg";